<template>
  <div class="d-flex justify-center">
    <v-card class="teach-table-form" width="100%" max-width="1000" :loading="loading" :disabled="loading">
      <v-card-text>
        <v-form ref="main_form" v-model="form_validate_status">
          <div :class="'pb-5 text-center lighten-1 deep-orange'">
            <h2 class="pt-4 font-weight-bold white--text">
              ตารางเรียน - ตารางสอบ
              ระดับ{{ isGraduate ? "บัณฑิตศึกษา" : "ปริญญาตรี" }}
            </h2>
            <h3 class="pt-2 text-body-2 font-weight-light white--text">
              ประจำภาคการศึกษาที่ {{ semester }} ปีการศึกษา {{ year }}
            </h3>
          </div>

          <v-divider></v-divider>
          <!-- ========================================================================= -->
          <v-card outlined class="mt-4">
            <v-card-title class="section-title">
              กำหนดรายวิชา
            </v-card-title>
            <v-card-text>
              <div class="subject-toolbar mb-3">
                <v-chip :color="mode_copy ? 'blue darken-2' : mode_edit ? 'deep-orange darken-2' : 'green darken-2'" dark class="font-weight-bold text-body-1 px-4">
                  คุณกำลังอยู่ในโหมด {{ mode_copy ? 'คัดลอก' : mode_edit ? 'แก้ไข' : 'เพิ่มใหม่' }}
                </v-chip>
                <v-btn small outlined color="black" @click="TeachTablePatternPdf()">
                  <v-icon small class="mr-1">mdi-file-pdf-box</v-icon>โครงสร้างตารางสอน
                </v-btn>
              </div>
              <v-row dense align="start">
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="input_subject_id"
                    label="รหัสวิชา *"
                    required
                    outlined dense maxlength="8"
                    :rules="[value => String(value || '').length === 8 || 'กรุณากรอกรหัสวิชา 8 ตัว']"
                    :loading="subject_loading"
                    :disabled="mode_edit && !mode_copy"
                    :error-messages="subject_lookup_failed ? 'ไม่พบข้อมูลวิชา กรุณาตรวจสอบรหัสวิชา' : []"
                    @input="filled_subject_id()"
                    hide-details="auto"
                  />
                </v-col>
                <v-col v-if="has_valid_subject" cols="12" md="6">
                  <div class="font-weight-bold mb-1">ชื่อวิชา:</div>
                  <div>{{ subject_data.subject_name_th }}</div>
                  <div class="text--secondary">{{ subject_data.subject_name_en }}</div>
                </v-col>
                <v-col v-if="has_valid_subject" cols="12" md="3">
                  <div class="font-weight-bold mb-1">หน่วยกิต (ท-ป-ศ):</div>
                  <div>{{ subject_data.credit }} ({{ subject_data.lect_hr }}-{{ subject_data.prac_hr }}-{{ subject_data.self_hr }})</div>
                </v-col>
              </v-row>
              <v-row dense class="mt-3" align="start">
                <v-col class="pt-1 pb-1" cols="12" md="3">
                  <v-text-field
                    v-model="section"
                    label="กลุ่ม *"
                    required
                    hide-details="auto"
                    outlined
                    dense
                    small
                    :disabled="mode_edit && mode_copy === false"
                    v-bind:rules="sectionRules"
                  ></v-text-field>
                </v-col>
                <v-col class="pt-1 pb-1" cols="12" md="9">
                  <v-alert type="warning" text dense class="mb-0">
                    กลุ่มเรียนต้องเป็นตัวเลข ไม่ขึ้นต้นด้วย 0 และไม่ซ้ำกับกลุ่มเดิม
                  </v-alert>
                </v-col>

              </v-row>
            </v-card-text>
          </v-card>
          <v-card outlined class="mt-4 blue lighten-5">
            <v-card-title class="section-title">
              กำหนดวัน - เวลาเรียน
            </v-card-title>
            <v-card-text class="pt-0">
              <TimeSlot ref="time_slot" :level-id="level_id"></TimeSlot>
            </v-card-text>
          </v-card>
          <!-- ========================================================================= -->

          <v-card outlined class="mt-4">
            <v-card-title class="section-title">กำหนดรายละเอียดวิชา</v-card-title>
            <v-card-text>
              <v-row>
                <v-col class="pt-1 pb-1" cols="12" :md="isGraduate ? 12 : 6">
                  <v-autocomplete
                    v-model="subject_type_id"
                    :label="isGraduate ? 'ประเภทวิชา *' : 'กลุ่มวิชา *'"
                    v-bind:items="subject_types"
                    v-bind:item-value="
                      (item) => item.TEACH_TABLE_SUBJECT_TYPE_ID
                    "
                    v-bind:item-text="
                      (item) =>
                        objectTranslator(item, 'TEACH_TABLE_SUBJECT_TYPE_NAME')
                    "
                    @change="update_subject_type"
                    clearable
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>
                <v-col v-if="!isGraduate" class="pt-1 pb-1" cols="12" md="6">
                  <v-autocomplete
                    v-model="subject_owner_id"
                    label="จัดสอนเอง/สอนบริการ *"
                    v-bind:items="subject_owners"
                    v-bind:item-value="
                      (item) => item.TEACH_TABLE_SUBJECT_OWNER_ID
                    "
                    v-bind:item-text="
                      (item) =>
                        objectTranslator(item, 'TEACH_TABLE_SUBJECT_OWNER_NAME')
                    "
                    clearable
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row class="mt-2">
                <v-col class="pt-1 pb-1" cols="12" md="6">
                  <v-autocomplete
                    v-model="lect_or_prac_id"
                    label="วิธีการสอน *"
                    required
                    :rules="[value => !!value || 'กรุณาเลือกวิธีการสอน']"
                    v-bind:items="lect_or_prac"
                    v-bind:item-value="(item) => item.id"
                    v-bind:item-text="(item) => item.text"
                    clearable
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>
                <v-col class="pt-1 pb-1" cols="12" md="6">
                  <v-autocomplete
                    v-model="teach_type_id"
                    label="ประเภทการสอน"
                    v-bind:items="teach_types"
                    v-bind:item-value="(item) => item.TEACH_TABLE_TEACH_TYPE_ID"
                    v-bind:item-text="
                      (item) =>
                        objectTranslator(item, 'TEACH_TABLE_TEACH_TYPE_NAME')
                    "
                    clearable
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row class="mt-2">
                <v-col cols="12" md="6" class="pt-1 pb-0">
                  <v-autocomplete
                    v-model="building_no"
                    label="อาคาร"
                    v-bind:items="buildings"
                    v-bind:item-value="(item) => item.building_no"
                    v-bind:item-text="(item) => item.building_name"
                    @change="(e) => update_building(e)"
                    clearable
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6" class="pt-1 pb-0">
                  <v-autocomplete
                    v-model="room_no"
                    label="ห้องเรียน"
                    v-bind:items="rooms"
                    v-bind:item-value="(item) => item.room_no"
                    v-bind:item-text="(item) => item.room_name"
                    clearable
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>

              </v-row>

            </v-card-text>
          </v-card>


          <v-card outlined class="mt-4">
            <v-card-title class="section-title">
              สอบกลางภาค
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col class="pt-1 pb-1" cols="12" md="4">
                  <DatePicker
                    v-model="midterm_exam_date"
                    label="ตารางสอบกลางภาค"
                    :no_required="true"
                  />
                </v-col>
                <v-col class="pt-1 pb-1" cols="12" md="4">
                  <TimePicker
                    v-model="midterm_exam_time_start"
                    label="เวลาเริ่ม"
                    :no_required="true"
                  ></TimePicker>
                </v-col>
                <v-col class="pt-1 pb-1" cols="12" md="4">
                  <TimePicker
                    v-model="midterm_exam_time_stop"
                    label="เวลาสิ้นสุด"
                    :no_required="true"
                  ></TimePicker>
                </v-col>
                <v-col class="pt-1 pb-3" cols="12">
                  <v-alert type="info" text dense class="mb-0">การแก้ไขวัน-เวลาสอบจะส่งผลกับทุกกลุ่มเรียน</v-alert>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card outlined class="mt-4">
            <v-card-title class="section-title">
              สอบปลายภาค
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col class="pt-1 pb-1" cols="12" md="6">
                  <v-autocomplete
                    v-model="exam_type_id"
                    label="วิธีการจัดสอบปลายภาค"
                    v-bind:items="exam_tpyes"
                    v-bind:item-value="(item) => item.TEACH_TABLE_EXAM_TYPE_ID"
                    v-bind:item-text="
                      (item) =>
                        objectTranslator(item, 'TEACH_TABLE_EXAM_TYPE_NAME')
                    "
                    clearable
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-1 pb-1" cols="12">
                  <v-alert type="info" text dense class="mb-0">
                    "ข้อความมาตรฐาน" ด้านล่าง จะแสดงให้ นศ.เห็น
                    เฉพาะกรณีวิธีการจัดเป็น 'จัดสอบเอง' หรือ 'จัดสอบออนไลน์'
                  </v-alert>
                </v-col>
                <v-col class="pt-1 pb-1" cols="12" md="6">
                  <v-autocomplete
                    v-model="exam_text_id"
                    label="ข้อความมาตรฐาน"
                    v-bind:items="exam_texts"
                    v-bind:item-value="(item) => item.TEACH_TABLE_EXAM_TEXT_ID"
                    v-bind:item-text="
                      (item) =>
                        objectTranslator(item, 'TEACH_TABLE_EXAM_TEXT_NAME')
                    "
                    clearable
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>
                <v-col
                  class="pt-1 pb-1"
                  cols="12"
                  v-if="this.exam_text_id == '3' || this.exam_text_id == '4'"
                >
                  <v-textarea
                    v-model="exam_text_detail"
                    label="กรอกข้อมูล"
                    outlined auto-grow rows="3" hide-details="auto"
                  ></v-textarea>
                </v-col>
                <v-col v-if="String(exam_text_id) === '3'" class="pt-1 pb-1" cols="12">
                  <v-alert type="info" text dense class="mb-0">
                    กรุณากรอก ลิ้งค์ (Link) ของคณะ ให้ถูกต้อง
                    ตัวอย่างการใส่ลิ้งค์ เช่น www.reg.kmitl.ac.th</v-alert>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-1 pb-1" cols="12" md="4">
                  <DatePicker
                    v-model="final_exam_date"
                    label="ตารางสอบปลายภาค"
                    :no_required="true"
                  />
                </v-col>
                <v-col class="pt-1 pb-1" cols="12" md="4">
                  <TimePicker
                    v-model="final_exam_time_start"
                    label="เวลาเริ่ม"
                    :no_required="true"
                  ></TimePicker>
                </v-col>
                <v-col class="pt-1 pb-1" cols="12" md="4">
                  <TimePicker
                    v-model="final_exam_time_stop"
                    label="เวลาสิ้นสุด"
                    :no_required="true"
                  ></TimePicker>
                </v-col>
                <v-col class="pt-1 pb-1" cols="12">
                  <v-alert type="info" text dense class="mb-0">การแก้ไขวัน-เวลาสอบจะส่งผลกับทุกกลุ่มเรียน</v-alert>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card outlined class="mt-4">
            <v-card-title class="section-title">
              กำหนดเงื่อนไขการลงทะเบียนเรียน
            </v-card-title>
            <v-card-text>
              <v-row dense align="center" class="mb-2">
                <v-col cols="12" md="6">
                  <div class="font-weight-bold mb-2">จำนวนรับนักศึกษา</div>
                  <v-radio-group v-model="inputLimitValue" row class="mt-0" hide-details>
                    <v-radio label="ไม่จำกัดจำนวนรับ" value="nonLimit"></v-radio>
                    <v-radio label="จำกัดจำนวนรับ" value="limit"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" md="6" v-if="inputLimitValue === 'limit'">
                  <v-text-field
                    v-model="limit"
                    label="จำนวนรับ (ระบุจำนวนนักศึกษาสูงสุดที่ต้องการรับ)"
                    type="number"
                    min="0"
                    outlined
                    dense
                    small
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-divider class="my-4"></v-divider>
              <RuleSlot ref="rule_slot" :level-id="level_id"></RuleSlot>
              <v-divider class="my-4" />
              <v-row>
                <v-col class="pt-1 pb-1" cols="12" md="12">
                  <v-text-field
                    v-model="remark"
                    label="หมายเหตุ (แสดงในตารางเรียน ไม่มีผลต่อเงื่อนไขการลงทะเบียน)"
                    outlined
                    dense
                    small
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-divider></v-divider>

          <config-show-teach-table-panel
            v-if="!isGraduate"
            ref="config_show_teach_table_panel"
            v-model="all_show_slot"
            :year="year"
            :semester="semester"
          />
          <graduate-config-show-teach-table-panel
            v-else
            ref="graduate_config_show_teach_table_panel"
            v-model="all_show_slot"
            :year="year"
            :semester="semester"
          />
        </v-form>
      </v-card-text>
      <v-card-actions class="save-actions pa-6">
        <div v-if="save_validation_messages.length" class="save-validation red--text text-body-2" role="status" aria-live="polite">
          <div>ยังบันทึกไม่ได้:</div>
          <ul class="mb-0 pl-5">
            <li v-for="message in save_validation_messages" :key="message">{{ message }}</li>
          </ul>
        </div>
        <v-spacer></v-spacer>
        <v-btn
          class="success white--text font-weight-bold text-h6"
          x-large
          min-width="180"
          height="56"
          @click="save_data()"
          :disabled="!save_data_enable"
          >บันทึก
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { objectTranslator, inlineTranslator } from "@/helper/translator";
import RefProvider from "@/services/ref.provider";
import { listFilter } from "@/helper/filter";
const refService = new RefProvider();
import genericProvider from "@/services/generic.provider.js";
import TimeSlot from "./TimeSlot.vue";
import RuleSlot from "./RuleSlot.vue";
const genericService = new genericProvider();
import DatePicker from "./DatePicker";
import TimePicker from "./TimePicker.vue";
import ConfigTeachTableProvider from "@/services/config_teach_table.provider.js";
const ConfigTeachTableService = new ConfigTeachTableProvider();
import * as dayjs from "dayjs";
import ConfigShowTeachTablePanel from "./ConfigShowTeachTablePanel.vue";
import GraduateConfigShowTeachTablePanel from "./GraduateConfigShowTeachTablePanel.vue";
import validator from "../../helper/validator";
export default {
  name: "ConfigTeachTable",

  data: () => ({
    loading: false,
    url_params: null,
    level_id: 1,
    input_subject_id: "",
    copy_from_subject_id: "",
    copy_from_section: "",
    teach_table_id: null,
    //-------------------------
    year: null,
    semester: null,
    faculty_id: null,
    permission_faculty_id: null,
    department_id: null,
    curriculum_id: null,
    curriculum2_id: null,
    branch_id: null,
    admission_type: null,
    admission_semester: null,
    year_class: null,
    //-------------------------
    subject_data: null,
    subject_loading: false,
    subject_lookup_failed: false,
    fetched_subject_id: null,
    subject_request_id: 0,
    subject_type_id: null,
    subject_owner_id: null,
    section: null,
    section_check: false,
    program: null, //หมายถึงชื่อเล่นของห้อง นศ. ที่คณะตั้งให้
    lect_or_prac_id: null,
    teach_type_id: null,
    building_no: null,
    room_no: null,
    check_room: false,
    teacher_id: null,
    midterm_exam_date: null,
    midterm_exam_time_start: null,
    midterm_exam_time_stop: null,
    exam_type_id: null,
    exam_text_id: null,
    exam_text_detail: null,
    final_exam_date: null,
    final_exam_time_start: null,
    final_exam_time_stop: null,
    limit: null,
    inputLimitValue: "nonLimit",
    remark: null,

    midterm_exam_day: null,
    final_exam_day: null,
    //-----------ส่วนนี้ค่าจะมาจาก Time Slot
    teach_day: null,
    teach_time_start: null,
    teach_time_stop: null,
    subject_types: [],
    subject_owners: [],
    teach_types: [],
    exam_tpyes: [],
    exam_texts: [],
    buildings: [],
    rooms: [],
    registrar_faculties: [],
    registrar_departments: [],
    registrar_curriculums: [],
    registrar_branches: [],
    registrar_admission_types: [],

    all_show_slot: [],

    lect_or_prac: [
      {
        id: "ท",
        text: "ทฤษฎี (lecture)",
      },
      {
        id: "ป",
        text: "ปฏิบัติ (practice)",
      },
    ],

    mode_edit: false,
    mode_copy: false,
    //--------------มีที่ต้องพิจารณา
    //ไม่ใช้แล้ว
    // room
    // building
    // sect
    //ไม่แน่ใจและไม่ได้ใช้
    // lock //น่าจะล๊อคไม่ให้แก้ไข ใน code เขียนว่า ระบบได้ปิดการแก้ไขข้อมูลตารางเรียนตารางสอบแล้วสามารถแก้ไขได้บางรายการเท่านั้น
    // sec_pair //น่าจะอยู่ที่เมนูอื่น
    // curr_type //เป็น 0 ไปเลยเพราะเป็นตารางเรียนตารางสอนแบบปกติ

    form_validate_status: null,
    sectionRules: [validator.required, validator.section],
  }),

  computed: {
    has_valid_subject() {
      return Boolean(
        String(this.input_subject_id || "").length === 8 &&
        this.fetched_subject_id === this.input_subject_id &&
        !this.subject_loading && this.subject_data &&
        (this.subject_data.subject_name_th || this.subject_data.subject_name_en)
      );
    },
    isGraduate() {
      return Number(this.level_id) === 2;
    },
    save_validation_messages() {
      const missing = [];
      if (!this.has_valid_subject) {
        missing.push(this.subject_loading ? "รอผลค้นหารหัสวิชา" : "รหัสวิชา 8 ตัวที่ค้นพบข้อมูล");
      }
      if (!/^[1-9]\d*$/.test(String(this.section || ""))) missing.push("กลุ่มเรียนที่ถูกต้อง (ไม่ขึ้นต้นด้วย 0)");
      if (!this.lect_or_prac_id) missing.push("วิธีการสอน");
      if (!this.all_show_slot.length) missing.push("เพิ่มข้อมูลการแสดงในหน้าตารางสอนอย่างน้อย 1 รายการ");
      if (this.isGraduate) {
        const fields = [
          [this.year, "ปีการศึกษา"], [this.semester, "ภาคการศึกษา"],
        ];
        fields.forEach(([value, label]) => { if (!value) missing.push(label); });
        // Display dimensions belong to SHOW, not the legacy main record.
        const displayFields = [
          ["FACULTY_ID", "คณะ"], ["DEPARTMENT_ID", "ภาควิชา"],
          ["CURRICULUM_ID", "สาขาวิชา"], ["ADMIS_TYPE", "ประเภทการรับเข้า"],
          ["TERM_ADMIS", "ภาคเรียนที่เข้า"],
        ];
        this.all_show_slot.forEach((slot, index) => {
          displayFields.forEach(([key, label]) => {
            const value = slot && slot[key];
            // Numeric/string 0 and x are valid legacy/all-selection values.
            const present = (typeof value === "string" || typeof value === "number")
              && String(value).trim() !== "";
            if (!present) missing.push(`ข้อมูลการแสดงแถวที่ ${index + 1}: ${label}`);
            else if (key === "FACULTY_ID" && !/^[0-9]{2}$/.test(String(value).trim()))
              missing.push(`ข้อมูลการแสดงแถวที่ ${index + 1}: รหัสคณะไม่ถูกต้อง`);
          });
        });
        if (this.subject_type_id === null || this.subject_type_id === undefined || this.subject_type_id === "") missing.push("ประเภทวิชา");
      }
      const form = this.$refs && this.$refs.main_form;
      if (form) {
        form.inputs.filter((input) => input.valid === false).forEach((input) => {
          const errors = input.errorBucket || [];
          if (errors.length) missing.push(`${input.label || "ข้อมูล"}: ${errors.join(', ')}`);
        });
      }
      if (this.form_validate_status === false && !missing.length) missing.push("ตรวจสอบช่องที่แสดงข้อผิดพลาดในแบบฟอร์ม");
      return [...new Set(missing)];
    },
    save_data_enable() {
      return !this.loading && this.form_validate_status === true && !this.save_validation_messages.length;
    },
  },

  components: {
    TimeSlot,
    RuleSlot,
    DatePicker,
    TimePicker,
    ConfigShowTeachTablePanel,
    GraduateConfigShowTeachTablePanel,
  },

  created() {
    const query = this.$route.query || {};
    this.level_id = Number(query.level_id || 1);
    this.year = query.year || null;
    this.semester = query.semester || null;
  },

  methods: {
    objectTranslator,
    inlineTranslator,
    listFilter,
    show_backend_error(error) {
      const data = error && error.response && error.response.data;
      const message =
        data && data.message
          ? data.message
          : error && error.message
          ? error.message
          : this.$t("config_teach_table.save_unsuccessfully");
      this.$toasted.error(
        typeof message === "string" ? message : JSON.stringify(message),
        { duration: 0 }
      );
    },
    async update_subject_type() {
      if (this.isGraduate) return;
      try {
        const subject_owners = await refService.getTeachTableSubjectOwner();
        this.subject_owners = subject_owners.filter(
          (item) => item.TEACH_TABLE_SUBJECT_TYPE_ID === this.subject_type_id
        );
      } catch (error) {
        this.show_backend_error(error);
      }
    },

    async get_data(teach_table_id) {
      const raw_data = this.isGraduate
        ? await ConfigTeachTableService.getGraduateTeachTableByTeachTableId(
            teach_table_id
          )
        : await ConfigTeachTableService.getTeachTableByTeachTableId(
            teach_table_id
          );
      if (!this.isGraduate && raw_data.length !== 1) {
        this.loading = true;
        this.$toasted.error("Teach Table length != 1");
        return;
      }
      const data = this.isGraduate ? raw_data : raw_data[0];
      this.input_subject_id = data.subject_id;
      if(this.mode_copy===true){
        this.copy_from_subject_id = data.subject_id;
        this.copy_from_section = data.section;
      }
      this.teach_table_id = data.TEACH_TABLE_ID;
      const nullableString = (value) =>
        value === null || value === undefined || value === ""
          ? null
          : String(value);
      if (this.isGraduate) {
        this.subject_owner_id = nullableString(data.subj_owner);
        this.subject_type_id = this.subject_owner_id
          ? String(Number(this.subject_owner_id) - 1)
          : nullableString(data.subj_type);
      } else {
        this.subject_type_id = nullableString(data.subj_type);
        this.subject_owner_id = nullableString(data.subj_owner);
      }
      if (!this.isGraduate && this.subject_type_id) {
        const subject_owners = await refService.getTeachTableSubjectOwner();
        this.subject_owners = subject_owners.filter(
          (item) => item.TEACH_TABLE_SUBJECT_TYPE_ID === this.subject_type_id
        );
      }
      if (this.isGraduate) {
        this.faculty_id = data.faculty_id;
        this.department_id = data.dept_id;
        this.curriculum_id = data.curr_id;
        this.branch_id = data.branch_id;
        this.admission_type = data.admis_type;
        this.admission_semester = data.term_admis;
      }
      this.year = data.year;
      this.semester = data.semester;
      this.program = data.program || null;
      this.section = data.section;
      this.lect_or_prac_id = nullableString(data.lect_or_prac);
      this.teach_type_id = nullableString(data.teach_type);
      this.building_no = this.isGraduate ? data.building : data.building_no;
      this.room_no = this.isGraduate ? data.room : data.room_no;
      this.midterm_exam_day = data.mexam_day;
      this.midterm_exam_date =
        data.mexam_date !== "0000-00-00" ? data.mexam_date : null;
      this.midterm_exam_time_start =
        data.mexam_time !== "00:00:00" ? data.mexam_time.substring(0, 5) : null;
      this.midterm_exam_time_stop =
        data.mexam_time2 !== "00:00:00"
          ? data.mexam_time2.substring(0, 5)
          : null;
      this.exam_type_id = nullableString(data.exam_type);
      this.exam_text_id = nullableString(data.exam_text_id);
      this.exam_text_detail = data.exam_text_detail;
      this.final_exam_day = data.exam_day;
      this.final_exam_date =
        data.exam_date !== "0000-00-00" ? data.exam_date : null;
      this.final_exam_time_start =
        data.exam_time !== "00:00:00" ? data.exam_time.substring(0, 5) : null;
      this.final_exam_time_stop =
        data.exam_time2 !== "00:00:00" ? data.exam_time2.substring(0, 5) : null;
      this.limit = data.limit;
      if (this.limit > 0) {
        this.inputLimitValue = "limit";
      }
      this.remark = data.remark;
      this.teach_day = data.teach_day;
      this.teach_time_start = data.teach_time;
      this.teach_time_stop = data.teach_time2;
      if (this.building_no) {
        const dataRooms = await genericService.getRegistrarRoom(
          this.building_no
        );
        this.rooms = dataRooms;
      }
    },

    async save_data() {
      if (!this.save_data_enable) {
        if (this.save_validation_messages.length) {
          this.$toasted.error(this.save_validation_messages.join(' / '), { duration: 5000 });
        }
        return;
      }
      if (!/^[1-9]\d*$/.test(String(this.section || ""))) {
        this.$toasted.error("กรุณาระบุกลุ่มเรียนเป็นตัวเลขที่ไม่ขึ้นต้นด้วย 0", { duration: 5000 });
        return;
      }
      if (!this.has_valid_subject) {
        this.$toasted.error("กรุณากรอกรหัสวิชา 8 ตัวและค้นพบข้อมูลวิชาก่อนบันทึก", { duration: 5000 });
        return;
      }
      this.loading = true;
      const midterm_exam_day_data = this.midterm_exam_date
        ? dayjs(this.midterm_exam_date, "YYYY-MM-dd").day()
        : null;
      const final_exam_day_data = this.final_exam_date
        ? dayjs(this.final_exam_date, "YYYY-MM-dd").day()
        : null;

      if (!this.isGraduate && this.all_show_slot.length === 0) {
        this.loading = false;
        return;
      }

      // const exam_show_slot = this.all_show_slot[0];

      // การคัดลอกเซต this.teach_table_id = null ให้เหมือนเป็นการ create เลย
      if (this.mode_copy === true) {
        this.teach_table_id = null;
      }
      const payload = {
        teach_table_id: this.teach_table_id
          ? String(this.teach_table_id)
          : null,
        permission_faculty_id: this.permission_faculty_id || this.faculty_id,
        schedule_details: {
          show: this.all_show_slot,
          times: (this.$refs.time_slot ? this.$refs.time_slot.all_time_slot : []).map((item) => ({
            start_date_time: item.start_date_time.format("YYYY-MM-DD HH:mm:ss"),
            end_date_time: item.end_date_time.format("YYYY-MM-DD HH:mm:ss"),
          })),
          rules: this.$refs.rule_slot ? this.$refs.rule_slot.all_rule_slot : [],
        },
        admission_type: this.admission_type,
        admission_semester: this.admission_semester,
        input_subject_id: this.input_subject_id,
        semester: this.semester,
        year: this.year,
        program: this.program,
        section: this.section,
        limit: this.inputLimitValue == "limit" ? this.limit : "0",
        room_no: this.room_no,
        building_no: this.building_no,
        midterm_exam_day: midterm_exam_day_data,
        midterm_exam_date: this.midterm_exam_date,
        midterm_exam_time_start: this.midterm_exam_time_start,
        midterm_exam_time_stop: this.midterm_exam_time_stop,
        final_exam_day: final_exam_day_data,
        final_exam_date: this.final_exam_date,
        final_exam_time_start: this.final_exam_time_start,
        final_exam_time_stop: this.final_exam_time_stop,
        exam_type_id: this.exam_type_id,
        lect_or_prac_id: this.lect_or_prac_id,
        remark: this.remark,
        subject_type_id: this.subject_type_id,
        subject_owner_id:
          this.isGraduate && this.subject_type_id !== null
            ? String(Number(this.subject_type_id) + 1)
            : this.subject_owner_id,
        teach_type_id: this.teach_type_id,
        exam_text_id: this.exam_text_id,
        exam_text_detail: this.exam_text_detail,
      };
      let response;
      try {
        response = await (this.isGraduate
          ? ConfigTeachTableService.saveGraduateTeachTable(payload)
          : ConfigTeachTableService.saveTeachTable(payload));
      } catch (error) {
        this.show_backend_error(error);
        this.loading = false;
        return;
      }

      if (response && response.status) {
        if (response.TEACH_TABLE_ID)
          this.teach_table_id = response.TEACH_TABLE_ID;

        if (this.teach_table_id && !response.details_saved) {
          if (this.$refs.time_slot) {
            const timeSlotSaved = await this.$refs.time_slot.save_to_db(
              String(this.level_id),
              this.teach_table_id
            );
            if (!timeSlotSaved) {
              this.loading = false;
              return;
            }
          }
          if (this.$refs.rule_slot) {
            const ruleSlotSaved = await this.$refs.rule_slot.save_to_db(
              String(this.level_id),
              this.teach_table_id
            );
            if (!ruleSlotSaved) {
              this.loading = false;
              return;
            }
          }
          if (!this.isGraduate && this.$refs.config_show_teach_table_panel) {
            const showSlotSaved = await this.$refs.config_show_teach_table_panel.save_to_db(
              "1",
              this.teach_table_id
            );
            if (!showSlotSaved) {
              this.loading = false;
              return;
            }
          }
          if (
            this.isGraduate &&
            this.$refs.graduate_config_show_teach_table_panel
          ) {
            const showSlotSaved = await this.$refs.graduate_config_show_teach_table_panel.saveToDb(
              this.teach_table_id
            );
            if (!showSlotSaved) {
              this.loading = false;
              return;
            }
          }
        }

        this.$toasted.success(
          this.$t("config_teach_table.save_data_successfully"),
          { duration: 0 }
        );

        let routeData = this.$router.resolve({
          name: "config_teach_table",
          query: {
            teach_table_id: this.teach_table_id,
            command: "update",
            permission_faculty_id: this.permission_faculty_id || this.faculty_id,
            level_id: this.level_id,
          },
        });
        window.open(routeData.href, "_self").focus();
        // location.reload();
      } else
        this.$toasted.error(this.$t("config_teach_table.save_unsuccessfully"));
      this.loading = false;
    },
    async delete_data() {
      try {
        await ConfigTeachTableService.deleteTeachTable({
          faculty_id: this.faculty_id,
          department_id: this.department_id,
          curriculum_id: this.curriculum_id,
          curriculum2_id: this.curriculum2_id,
          year: this.year,
          semester: this.semester,
          year_class: this.year_class,
          section: this.section,
          input_subject_id: this.input_subject_id,
        });
      } catch (error) {
        this.show_backend_error(error);
      }
    },
    filled_subject_id() {
      this.subject_data = null;
      this.fetched_subject_id = null;
      this.subject_lookup_failed = false;
      this.subject_loading = false;
      this.subject_request_id++;
      if (String(this.input_subject_id || "").length === 8) return this.get_subject_data();
    },
    async get_subject_data() {
      const requestedSubjectId = this.input_subject_id;
      const requestId = ++this.subject_request_id;
      this.subject_data = null;
      this.fetched_subject_id = null;
      this.subject_lookup_failed = false;
      this.subject_loading = false;
      if (String(requestedSubjectId || "").length !== 8) return;
      this.subject_loading = true;
      try {
        const data = await genericService.getRegistrarSubject(
          this.level_id,
          requestedSubjectId
        );
        if (requestId !== this.subject_request_id || requestedSubjectId !== this.input_subject_id) return;
        this.subject_data = data[0] || null;
        this.fetched_subject_id = requestedSubjectId;
        this.subject_lookup_failed = !this.subject_data ||
          !(this.subject_data.subject_name_th || this.subject_data.subject_name_en);

        if (!this.mode_edit && this.subject_data) {
          const { lect_hr } = this.subject_data;
          if (parseInt(lect_hr) > 0) this.lect_or_prac_id = "ท";
          else this.lect_or_prac_id = "ป";
        }
      } catch (error) {
        if (requestId === this.subject_request_id && requestedSubjectId === this.input_subject_id) {
          this.subject_data = null;
          this.subject_lookup_failed = true;
          this.show_backend_error(error);
        }
      } finally {
        if (requestId === this.subject_request_id) this.subject_loading = false;
      }
    },
    async update_building(building_no) {
      this.room_no = null;
      try {
        const dataRooms = await genericService.getRegistrarRoom(building_no);
        this.rooms = dataRooms;
      } catch (error) {
        this.rooms = [];
        this.show_backend_error(error);
      }
    },
    async fetch_data() {
      if (this.building_no) {
        const dataRooms = await genericService.getRegistrarRoom(
          this.building_no
        );
        this.rooms = dataRooms;
      }
    },
    async init_data() {
      this.level_id = Number(this.$route.query.level_id || 1);
      if (this.isGraduate) {
        const subject_owners = await refService.getGraduateSubjectOwner();
        this.subject_types = (subject_owners || []).map((item) => ({
          // registrar.x_teach_table.subj_type ใช้ค่า 0-5 แต่ SUBJECT_OWNER_ID ใช้ 1-6
          TEACH_TABLE_SUBJECT_TYPE_ID: String(
            Number(item.SUBJECT_OWNER_ID) - 1
          ),
          TEACH_TABLE_SUBJECT_TYPE_NAME_TH: item.SUBJECT_OWNER_NAME_TH,
          TEACH_TABLE_SUBJECT_TYPE_NAME_EN: item.SUBJECT_OWNER_NAME_EN,
        }));
      } else {
        const subject_types = await refService.getTeachTableSubjectType();
        this.subject_types = subject_types;
      }
      const teach_types = await refService.getTeachTableTeachType();
      this.teach_types = teach_types;
      const exam_tpyes = await refService.getTeachTableExamType();
      this.exam_tpyes = exam_tpyes;
      const exam_texts = await refService.getTeachTableExamText();
      this.exam_texts = exam_texts;
      const buildings = await genericService.getRegistrarBuilding();
      this.buildings = buildings;
      const faculties = await genericService.getRegistrarFaculty();
      this.registrar_faculties = faculties;

      if (this.isGraduate) {
        const [
          departments,
          level2Curriculums,
          level3Curriculums,
          branches,
          level2AdmissionTypes,
          level3AdmissionTypes,
        ] =
          await Promise.all([
            genericService.getAllRegistrarDepartment(),
            genericService.getCurriculum({ LEVEL_ID: 2 }),
            genericService.getCurriculum({ LEVEL_ID: 3 }),
            genericService.getAllRegistrarBranch(),
            refService.getStudyAdmitTypeByLevel(2),
            refService.getStudyAdmitTypeByLevel(3),
          ]);
        this.registrar_departments = departments || [];
        this.registrar_curriculums = [
          ...(level2Curriculums || []).map((item) => ({
            ...item,
            LEVEL_ID: 2,
          })),
          ...(level3Curriculums || []).map((item) => ({
            ...item,
            LEVEL_ID: 3,
          })),
        ];
        this.registrar_branches = branches || [];
        this.registrar_admission_types = [
          ...(level2AdmissionTypes || []).map((item) => ({
            ...item,
            LEVEL_ID: 2,
          })),
          ...(level3AdmissionTypes || []).map((item) => ({
            ...item,
            LEVEL_ID: 3,
          })),
        ];
      }

      await this.fetch_data();
      await this.get_url_data();
    },
    // ================================================================
    async get_url_data() {
      let params = {};
      if (this.$route.query) params = this.$route.query;
      this.url_params = params;
      this.permission_faculty_id = params.permission_faculty_id || params.faculty_id || null;
      const level_id = String(params.level_id || this.level_id || 1);
      this.level_id = Number(level_id);

      if (params.command === "create") {
        this.mode_edit = false;

        this.level_id = level_id;
        this.year = params.year;
        this.semester = params.semester;
        this.faculty_id = params.faculty_id;
        this.department_id = params.dept_id;
        this.curriculum2_id = params.curr2_id;
        this.curriculum_id = params.curr_id;
        this.year_class = params.class;
        this.branch_id = params.branch_id || null;
        this.admission_type = params.admission_type || null;
        this.admission_semester = params.admission_semester || null;

        if (!this.isGraduate && this.$refs.config_show_teach_table_panel)
          this.$refs.config_show_teach_table_panel.new_default_show_slot({
          year: params.year,
          semester: params.semester,
          faculty_id: params.faculty_id,
          department_id: params.dept_id,
          curriculum2_id: params.curr2_id,
          year_class: params.class,
          });
        if (
          this.isGraduate &&
          this.$refs.graduate_config_show_teach_table_panel
        )
          this.$refs.graduate_config_show_teach_table_panel.newDefaultShowSlot({
            facultyId: params.faculty_id,
            departmentId: params.dept_id,
            curriculumId: params.curr_id,
            branchId: params.branch_id || null,
            admissionType: params.admission_type,
            admissionSemester: params.admission_semester,
          });
      }
      if (params.command === "update" || params.command === "copy") {
        this.loading = true;
        this.mode_edit = true;
        if (params.command === "copy") {
          this.mode_copy = true;
        }
        this.teach_table_id = params.teach_table_id;

        if (!this.isGraduate && params.command === "update") {
          this.faculty_id = params.faculty_id || null;
        }

        await this.get_data(params.teach_table_id);
        await this.get_subject_data();

        if (this.mode_copy) {
          this.section = null;
        }

        if (this.teach_table_id) {
          if (this.$refs.time_slot)
            await this.$refs.time_slot.get_time_slot(
              level_id,
              this.teach_table_id
            );
          if (this.$refs.rule_slot)
            await this.$refs.rule_slot.get_rule_slot(
              level_id,
              this.teach_table_id
            );
          if (!this.isGraduate && this.$refs.config_show_teach_table_panel)
            await this.$refs.config_show_teach_table_panel.get_show_slot(
              level_id,
              this.teach_table_id
            );
          if (
            this.isGraduate &&
            this.$refs.graduate_config_show_teach_table_panel
          )
            await this.$refs.graduate_config_show_teach_table_panel.getShowSlot(
              this.teach_table_id
            );
        }

        this.loading = false;
      }
    },
    // ================================================================
    TeachTablePatternPdf: function() {
      window.open(
        "https://www.reg.kmitl.ac.th/storage/reg/TeachTablePattern.pdf",
        "_blank"
      );
    },
  },
  async mounted() {
    try {
      await this.init_data();
      if (this.input_subject_id.length === 8) await this.get_subject_data();
    } catch (error) {
      this.loading = false;
      this.show_backend_error(error);
    }
  },
};
</script>

<style scoped>
.save-actions {
  flex-wrap: wrap;
  gap: 8px;
}
.save-validation {
  flex: 1 1 320px;
}
.subject-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}
.teach-table-form ::v-deep .display-card > .v-card__title,
.teach-table-form ::v-deep .display-card > .v-card__subtitle {
  color: white;
}

.teach-table-form ::v-deep .v-data-table table {
  border-collapse: collapse;
  border: 1px solid #d6d6d6;
}
.teach-table-form ::v-deep .v-data-table table th,
.teach-table-form ::v-deep .v-data-table table td {
  border: 1px solid #d6d6d6 !important;
}

.teach-table-form ::v-deep .v-card__title {
  padding: 16px;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.5;
  color: #f4511e;
  overflow-wrap: anywhere;
}
.teach-table-form ::v-deep .v-card__text {
  padding: 16px;
}
.teach-table-form ::v-deep .v-card__title + .v-card__text {
  padding-top: 4px;
}

.compact-form {
  transform: scale(0.875);
  transform-origin: left;
}

</style>
